module.exports = "/assets/3edda96af684a12ae9a8f2cd2fad43fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/WG.png
// module id = 3078
// module chunks = 0